<script setup lang="ts">
import { computed } from 'vue'

const { isAuthenticated, userInfo } = useUser()

const userInitials = computed(() => {
  if (!isAuthenticated.value || !userInfo.value) {
    return ''
  }

  const firstname = userInfo.value.firstName || ''
  const lastname = userInfo.value.lastName || ''
  return (firstname.charAt(0) + lastname.charAt(0)).toUpperCase()
})
</script>

<template>
  <!-- The initials render in the `fallback` slot, so the colour has to go there rather than on
       the root: KIT green on the avatar's own bg-primary/10 is only 4.29:1 in dark mode. -->
  <UAvatar
    :text="userInitials"
    color="primary"
    class="text-sm!"
    :ui="{ fallback: 'text-[var(--app-text-primary)]' }"
  />
</template>
